module.exports = __webpack_public_path__ + "static/media/8440.d3bada25.jpg";